export default __webpack_public_path__ + "assets/images/c7b6eba15aac234a341b2167ccf29956.png";